import { Component } from 'react';
import PersonnelList from './personnel-list';
import {
  setPersonnelLockoutStatus,
  editPersonnel,
  getAllPersonnel,
  getPersonnelRevised,
  getPersonnel,
  addOrganization,
  addPersonnel,
} from '../../../../modules/user_api';
import OrganizationCard from './organization-card';
//import OrganizationForm from "./organization-form";

import './manage-personnel.css';

const PAGE_SIZE = 10;

class ManagePersonnel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gettingPersonnel: false,
      addingPersonnel: false,
      personnel: [],
      errors: [],
      organizationFormErrors: [],
      selected_organizations: [],
      shouldHideForm: false,
      addingOrganization: false,
      show_organization_form: false,
      query: '',
      page: 1,
      total_pages: 1,
      loading: true,
    };
  }

  componentDidMount() {
    this.getPersonnelRevised();
  }

  updateQuery(query) {
    this.setState({ query: query, page: 1 }, this.getPersonnelRevised);
  }

  updatePage(page) {
    this.setState({ page }, this.getPersonnelRevised);
  }

  async getPersonnelRevised() {
    const { page, query, selected_organizations } = this.state;

    this.setState({ loading: true });
    const organizationIds = [];
    for (let i = 0; i < selected_organizations.length; i++) {
      const currentOrganization = selected_organizations[i];
      organizationIds.push(currentOrganization.id);
    }

    const response = await getPersonnelRevised({ query, page, organizationIds });
    const data = response.data;

    const personnelData = data.personnel;
    const toalPersonnel = data.total;

    const totalPages = Math.ceil(toalPersonnel / PAGE_SIZE);

    this.setState({ personnel: personnelData, total_pages: totalPages, loading: false });
  }

  async getAllPersonnel() {
    const { gettingPersonnel } = this.state;

    if (gettingPersonnel) {
      return;
    }

    this.setState({ gettingPersonnel: true });

    const personnelResponse = await getAllPersonnel();

    if (personnelResponse.data && personnelResponse.data.success) {
      const personnelData = personnelResponse.data.personnel;
      this.setState({ gettingPersonnel: false, personnel: personnelData });
    } else {
      if (personnelResponse.data) {
        alert(personnelResponse.data.message);
      } else {
        alert('Something went wrong...');
      }

      this.setState({ gettingPersonnel: false });
    }
  }

  toggleCurrentOrganization(organization) {
    const { selected_organizations } = this.state;
    const newSelectedOrganizations = [];
    let found = false;
    for (let i = 0; i < selected_organizations.length; i++) {
      const currentOrganization = selected_organizations[i];

      if (currentOrganization.id === organization.id) {
        found = true;
      } else {
        newSelectedOrganizations.push(currentOrganization);
      }
    }

    if (!found) {
      newSelectedOrganizations.push(organization);
    }

    this.setState({ selected_organizations: newSelectedOrganizations, page: 1 }, this.getPersonnelRevised);
  }

  removeArchivedPersonnel(personnelID) {
    const { personnel } = this.state;
    const newPersonnelList = [];

    for (const index in personnel) {
      const currentPersonnel = personnel[index];
      if (currentPersonnel.id !== personnelID) {
        newPersonnelList.push(currentPersonnel);
      }
    }
    this.setState({ personnel: newPersonnelList });
  }

  addNewlyAddedPersonnelTolist(newPersonnelInfo) {
    const { personnel } = this.state;
    const newPersonnelList = [...personnel, newPersonnelInfo];
    this.setState({ personnel: newPersonnelList });
  }

  updatePersonnelLockoutStatusDone(personnelID, newLockoutStatus) {
    const { personnel } = this.state;
    const newPersonnel = [];

    for (const index in personnel) {
      const currentPersonnel = personnel[index];

      if (currentPersonnel.id === personnelID) {
        currentPersonnel.lockout = newLockoutStatus;
        newPersonnel.push(currentPersonnel);
      } else {
        newPersonnel.push(currentPersonnel);
      }
    }

    this.setState({ personnel: newPersonnel });
  }

  updateEditedPersonnel(editedPersonnelData) {
    const { personnel } = this.state;
    const newPersonnel = [];

    for (const index in personnel) {
      const currentPersonnel = personnel[index];

      if (currentPersonnel.id === editedPersonnelData.id) {
        newPersonnel.push(editedPersonnelData);
      } else {
        newPersonnel.push(currentPersonnel);
      }
    }

    this.setState({ personnel: newPersonnel });
  }

  personnelFormHidden() {
    this.setState({ shouldHideForm: false, errors: [] });
  }

  async editPersonnel(personnelID, editData) {
    const { addingPersonnel } = this.state;

    if (addingPersonnel) {
      return;
    }

    this.setState({ addingPersonnel: true, errors: [] });

    const esitPersonnelResponse = await editPersonnel(personnelID, editData);

    if (esitPersonnelResponse && esitPersonnelResponse.data) {
      const data = esitPersonnelResponse.data;

      if (data.success) {
        //Add new personnel to the list

        this.updateEditedPersonnel(data.edited_personnel_data);

        this.setState({
          shouldHideForm: true,
        });
      } else {
        const errorMessage = data.message;
        this.setState({ errors: [errorMessage] });
      }
    } else {
      //Something went wrong while adding personnel.
    }
    this.setState({ addingPersonnel: false });
  }

  showOrganizationForm() {
    this.setState({ show_organization_form: true });
  }

  closeOrganizationForm() {
    this.setState({ show_organization_form: false });
  }

  async setLockoutStatus(personnelID, newStatus) {
    const setResponse = await setPersonnelLockoutStatus(personnelID, newStatus);

    if (setResponse.data.success) {
      this.updatePersonnelLockoutStatusDone(personnelID, newStatus);
    }
  }

  async addOrganization(organizationName) {
    const { add_new_organization_func } = this.props;
    const { addingOrganization } = this.state;

    if (addingOrganization) {
      return;
    }

    this.setState({ addingOrganization: true });

    const addOrganizationResult = await addOrganization(organizationName);

    if (addOrganizationResult && addOrganizationResult.data) {
      const data = addOrganizationResult.data;

      if (data.success) {
        add_new_organization_func(data.new_organization);
        this.setState({ show_organization_form: false });
      } else {
        const errorMessage = data.message;
        this.setState({ organizationFormErrors: [errorMessage] });
      }
    }
    this.setState({ addingOrganization: false });
  }

  async addPersonnel(newPersonnelData) {
    const { addingPersonnel } = this.state;

    if (addingPersonnel) {
      return;
    }

    this.setState({ addingPersonnel: true, errors: [] });

    const addPersonnelResponse = await addPersonnel(newPersonnelData);

    if (addPersonnelResponse && addPersonnelResponse.data) {
      const data = addPersonnelResponse.data;

      if (data.success) {
        //Add new personnel to the list

        this.addNewlyAddedPersonnelTolist(data.new_personnel);

        this.setState({
          shouldHideForm: true,
        });
      } else {
        const errorMessage = data.message;
        this.setState({ errors: [errorMessage] });
      }
    } else {
      //Something went wrong while adding personnel.
    }
    this.setState({ addingPersonnel: false });
  }

  async getPersonnel(organization) {
    const { gettingPersonnel } = this.state;

    if (gettingPersonnel) {
      return;
    }

    this.setState({ gettingPersonnel: true, current_organization: organization });

    const personnelResponse = await getPersonnel(organization.id);

    if (personnelResponse.data && personnelResponse.data.success) {
      const personnelData = personnelResponse.data.personnel;
      this.setState({ gettingPersonnel: false, personnel: personnelData });
    } else {
      if (personnelResponse.data) {
        alert(personnelResponse.data.message);
      } else {
        alert('Something went wrong...');
      }
      this.setState({ gettingPersonnel: false });
    }
  }

  printOrgs() {
    const { organizations } = this.props;
    const { selected_organizations } = this.state;

    return organizations.map((organization) => {
      let isCurrent = false;
      for (let i = 0; i < selected_organizations.length; i++) {
        const currentOrganization = selected_organizations[i];

        if (currentOrganization.id === organization.id) {
          isCurrent = true;
          break;
        }
      }
      return (
        <OrganizationCard
          key={organization.id}
          organization={organization}
          is_current={isCurrent}
          on_click={this.toggleCurrentOrganization.bind(this)}
        />
      );
    });
  }

  render() {
    const { organizations, roles } = this.props;
    const { personnel, selected_organizations, errors, shouldHideForm, total_pages, loading } = this.state;
    return (
      <div>
        <div className="manage_personnel_organizations_section">
          <div className="manage_personnel_organizations_section_title">
            <span>Your Facilities: </span>
          </div>
          {this.printOrgs()}
        </div>
        {
          <PersonnelList
            archive_done={this.removeArchivedPersonnel.bind(this)}
            personnel_data={personnel}
            add_personnel={this.addPersonnel.bind(this)}
            edit_personnel={this.editPersonnel.bind(this)}
            selected_organizations={selected_organizations}
            roles={roles}
            organizations={organizations}
            errors={errors}
            should_hide_form={shouldHideForm}
            personnel_form_hidden={this.personnelFormHidden.bind(this)}
            set_personnel_lockout={this.setLockoutStatus.bind(this)}
            update_query={this.updateQuery.bind(this)}
            update_page={this.updatePage.bind(this)}
            total_pages={total_pages}
            loading={loading}
          />
        }
      </div>
    );
  }
}

export default ManagePersonnel;
